<script setup>
import VCancel from "@/Components/VCancel.vue";
import FosteringContactFormLayout from "@/Layouts/FosteringContactFormLayout.vue";
import AdditionalComments from "@/Pages/SouthEastBrochure/Partials/AdditionalComments.vue";
import ContactDetails from "@/Pages/SouthEastBrochure/Partials/ContactDetails.vue";
import Details from "@/Pages/SouthEastBrochure/Partials/Details.vue";
import Footer from "@/Pages/SouthEastBrochure/Partials/Footer.vue";
import FosteringExperience from "@/Pages/SouthEastBrochure/Partials/FosteringExperience.vue";
import Location from "@/Pages/SouthEastBrochure/Partials/Location.vue";
import { Head, useForm, usePage } from '@inertiajs/vue3';


const form = useForm({
    forename: null,
    surname: null,
    phoneNumber: null,
    email: null,

    postcode: null,
    localAuthority: null,

    experience: null,
    experience_id: null,
    experienceDetails: null,

    contactAnyTime: null,
    termsAndConditions: null,
    contactTimeSchedule: null,

    initialComments: null,
    firstHeard: null,
    firstHeardOther: null,
})

const submit = () => {
    form.post(route('south-east.fostering-ambassador.form.submit'))
}

const cancel = () => {
    window.location.href = 'https://www.lafosteringse.org.uk'
}

const { headerLogo, firstExternalContactSources } = usePage().props
const telephoneNumber = import.meta.env.VITE_SE_FOOTER_PHONE_NUMBER || '';
</script>

<template>
    <Head title="Fostering - South East"/>
    <FosteringContactFormLayout layout="SE" title="Contact us" header-colour="white" footer-colour="footer">
        <template v-slot:header>
            <div class="d-none d-md-block">
                <a href="https://www.lafosteringse.org.uk/"
                   tabindex="1"
                   autofocus
                >
                    <img
                        :src="headerLogo"
                        alt="Fostering South East Logo"
                        aria-label="Fostering South East Logo"
                        class="py-4 px-4"
                        height="148"
                    />
                </a>
            </div>
        </template>
        <template v-slot:default>
            <form @submit.prevent="submit">
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <p class="mb-6" tabindex="4">
                            Would you like to speak to a foster carer to find out what fostering in the South East is really like? We have a team of amazing fostering ambassadors with lots of first-hand experience of caring for children, who would love to chat with you.
                        </p>
                        <br/>
                        <p tabindex="5">
                            Please complete the <strong>enquiry form below</strong> and one of our experienced carers will be in touch for a commitment-free chat.
                        </p>
                        <br/>
                        <p class="mb-6" tabindex="6">
                            Alternatively, you can call us on <strong><a class="se-hyperlink-bg" :href="'tel:' + telephoneNumber" target="_blank">
                            {{ telephoneNumber }}
                        </a></strong> or send an email to <a href="mailto:info@lafosteringse.org.uk" tabindex="6" class="se-hyperlink-bg">info@lafosteringse.org.uk</a>.
                        </p>
                        <p class="mt-3" tabindex="7">
                            <small>
                                * indicates a required field
                            </small>
                        </p>
                    </v-col>
                    <v-col cols="12" md="4" >
                        <Details :form="form"/>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" xl="4">
                        <v-row>
                            <v-col cols="12">
                                <Location :form="form"/>
                            </v-col>
                            <v-col cols="12">
                                <FosteringExperience :form="form"/>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="4" lg="4" xl="4">
                        <v-row>
                            <v-col cols="12">
                                <ContactDetails :form="form"/>
                            </v-col>
                            <v-col cols="12">
                                <AdditionalComments :form="form" :firstExternalContactSources="firstExternalContactSources"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="d-flex">
                    <v-col cols="6">
                        <v-cancel @cancel="cancel()"/>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end">
                        <v-btn type="submit" text="Submit"/>
                    </v-col>
                </v-row>
            </form>
        </template>
        <template v-slot:footer>
            <Footer/>
        </template>
    </FosteringContactFormLayout>
</template>

<style scoped>

</style>

<style>

</style>
